<template>
  <el-form-item :label="label" :prop="field" :rules="rules" size="small">
    <span slot="label">
      <span class="form-item__label">{{ label }}</span>
      <span class="form-item__tip" v-if="tip" v-html="`(${tip})`"></span>
    </span>
    <el-input type="textarea" :value="value" @input="$emit('input', $event)" :rows="rows" :placeholder="placeholder"></el-input>
  </el-form-item>
</template>

<script>
export default {
  name: 'app-type-textarea',
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    field: {
      type: String
    },
    tip: {
      type: String,
      default: ''
    },
    rules: {
      type: [ Object, Array ]
    },
    value: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 2
    },
    placeholder: {
      type: String,
      default: '请在此输入内容'
    }
  }
}
</script>
